import { GUID, Param } from "app/brightserve/brightserve.module";

import {Incident} from "./incident";
import {Person} from "./person";


export class Observation {

    Id: GUID;
    Incident: Incident;
    Patient: Person;
    Type: Param;
    ObservationDate: Date;

    ManualEntry: boolean;
    Value1: number;
    Value2: number;
    Value3: number;
    Value4: number;
    Value5: number;
    Value6: number;
    Value7: number;
    Value8: number;
    Value9: number;
    Value10: number;
    Value11: number;
    Value12: number;

    constructor(init?: Partial<Observation>) {
        Object.assign(this, init);

        if (init && init.ObservationDate) {
            this.ObservationDate = new Date(init.ObservationDate);
        } else {
            this.ObservationDate = null;
        };

        if (init && init.Incident) {
            this.Incident = new Incident(init.Incident);
        } else {
            this.Incident = null;
        };

        if (init && init.Patient) {
            this.Patient = new Person(init.Patient);
        } else {
            this.Patient = null;
        };

        if (init && init.Type) {
            this.Type = new Param(init.Type);
        } else {
            this.Type = null;
        };
    };
}



// WEBPACK FOOTER //
// ./src/app/shared/observation.ts